import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
// --- Sankoloner truti thik korar jonno mock implementation ---
// import { useLoadScript } from "@react-google-maps/api";
// import usePlacesAutocomplete, {
//   getGeocode,
//   getLatLng,
// } from "use-places-autocomplete";
// import { AuthContext } from "../context/AuthProvider";

// --- START: MOCKS TO FIX RESOLUTION ERRORS ---

// AuthContext er jonno mock, local import truti thik korar jonno
const AuthContext = React.createContext({
  user: {
    displayName: "Guest User",
    email: "guest@example.com",
    firstName: "Guest",
    lastName: "User",
    phone: "0123456789",
  },
  setUser: () => {},
});

// Google Maps-er jonno mock hook ebong function
const useLoadScript = ({ googleMapsApiKey, libraries }) => {
  // Script thikthak moto load hoyeche sheta simulate korchi
  return {
    isLoaded: true,
    loadError: null,
  };
};

const getGeocode = (params) => {
  // Address ba location theke geocode data fetch korar simulation
  return new Promise((resolve, reject) => {
    console.log("MOCK getGeocode called with:", params);
    if (params.address || params.location) {
      resolve([
        {
          formatted_address: "10 Downing St, Westminster, London SW1A 2AA, UK",
          address_components: [
            { long_name: "10", types: ["street_number"] },
            { long_name: "Downing Street", types: ["route"] },
            { long_name: "London", types: ["postal_town"] },
            { long_name: "Westminster", types: ["locality"] },
            { long_name: "SW1A 2AA", types: ["postal_code"] },
            { long_name: "United Kingdom", types: ["country"] },
          ],
          geometry: {
            location: { lat: () => 51.5034, lng: () => -0.1276 },
          },
        },
      ]);
    } else {
      reject(
        new Error("MOCK: Geocoding error. No address or location provided.")
      );
    }
  });
};

const getLatLng = (result) => {
  // Geocode result theke lat/lng ber korar simulation
  return new Promise((resolve) => {
    console.log("MOCK getLatLng called with:", result);
    const location = result.geometry.location;
    resolve({ lat: location.lat(), lng: location.lng() });
  });
};

const usePlacesAutocomplete = ({ requestOptions, debounce }) => {
  const [value, setValue] = useState("");

  // User type korle address suggestion dewar simulation
  const suggestions = {
    status: "OK",
    data: [
      {
        place_id: "mock_place_1",
        description: "10 Downing Street, London, UK",
      },
      {
        place_id: "mock_place_2",
        description: "Buckingham Palace, London, UK",
      },
      { place_id: "mock_place_3", description: "The Shard, London, UK" },
    ],
  };

  const clearSuggestions = () => {
    // Bastobe ekhane suggestion list clear hobe
  };

  return {
    ready: true, // Dhore nicchi service shobshomoy ready
    value,
    suggestions: value ? suggestions : { status: "", data: [] }, // Input thaklei shudhu suggestion dekhabe
    setValue,
    clearSuggestions,
  };
};

// --- END: MOCKS TO FIX RESOLUTION ERRORS ---

// Item er price ber korar jonno helper function
const getItemPrice = (item) => {
  const priceString =
    item?.selectedAttributes?.other_attributes?.discount_price ||
    item?.discount_price ||
    item?.price ||
    "0";
  return parseFloat(priceString);
};

// --- CONFIGURATION ---
const LIBRARIES = ["places", "geocoding", "routes"]; // Google Maps libraries

const Checkout = () => {
  const [userCoords, setUserCoords] = useState(null);
  const [shopCoords, setShopCoords] = useState(null);
  const [newShippingCost, setNewShippingCost] = useState(0);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8080/api/";
  const location = useLocation();
  const googleMapsApiKey =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "MOCK_API_KEY";
  const [initialDetectionAttempted, setInitialDetectionAttempted] =
    useState(false);

  // --- Google Maps Script Load ---
  const { isLoaded: isGoogleMapsLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries: LIBRARIES,
  });

  // Ei effect ti global `google.maps` object-ke mock kore
  useEffect(() => {
    if (isGoogleMapsLoaded && !window.google) {
      window.google = {
        maps: {
          LatLng: function (lat, lng) {
            return { lat: () => lat, lng: () => lng };
          },
          DirectionsService: function () {
            return {
              route: function (request, callback) {
                // Mock distance diye route calculation simulate korchi
                const mockDistanceInMeters = Math.random() * 30000 + 5000;
                const result = {
                  routes: [
                    {
                      legs: [
                        {
                          distance: { value: mockDistanceInMeters },
                        },
                      ],
                    },
                  ],
                };
                console.log("MOCK DirectionsService responding with:", result);
                callback(result, "OK");
              },
            };
          },
        },
      };
    }
  }, [isGoogleMapsLoaded]);

  // Component mount hole backend theke shop coordinates fetch korchi
  useEffect(() => {
    axios
      .get(`${baseUrl}shop`)
      .then((res) => {
        const shop = res?.data?.shopData?.location;
        if (shop && shop.latitude && shop.longitude) {
          setShopCoords({
            lat: shop.latitude,
            lng: shop.longitude,
          });
        }
      })
      .catch((err) => {
        console.error("Failed to fetch shop coordinates:", err);
        setShopCoords({ lat: 51.5074, lng: -0.1278 }); // Mock London
        toast.error(
          "Could not load shop location. Using default for calculation."
        );
      });
  }, [baseUrl]);

  const productsFromCart = location.state?.product || [];
  const appliedCouponFromCart = location.state?.appliedCouponData || null;
  const finalTotalAmountFromCart = location.state?.finalTotalAmount;

  const { user } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    country: "",
    streetAddress: "",
    streetAddressExtra: "",
    town: "",
    pinCode: "",
    phone: "",
    email: "",
    latitude: "",
    longitude: "",
  });

  const [errors, setErrors] = useState({});
  const [deliveryPriority, setDeliveryPriority] = useState("standard");
  const [shippingCost, setShippingCost] = useState(0);
  const [isCalculatingShipping, setIsCalculatingShipping] = useState(false);
  const [isDetectingLocation, setIsDetectingLocation] = useState(false);

  // --- AUTOCOMPLETE HOOKS ---
  const {
    ready,
    value: placesValue,
    suggestions: { status, data: suggestions },
    setValue: setPlacesValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: { country: "uk" },
    },
    debounce: 300,
  });

  // --- FORM & DATA MANAGEMENT EFFECTS ---

  // Saved data ba user data diye form populate korar effect
  useEffect(() => {
    const savedData = localStorage.getItem("checkoutFormSimplified");
    let initialFormData = {
      firstName: "",
      lastName: "",
      country: "",
      streetAddress: "",
      streetAddressExtra: "",
      town: "",
      pinCode: "",
      phone: "",
      email: "",
      latitude: "",
      longitude: "",
    };

    if (savedData) {
      try {
        initialFormData = { ...initialFormData, ...JSON.parse(savedData) };
      } catch (e) {
        console.error("Error parsing saved checkout data:", e);
        localStorage.removeItem("checkoutFormSimplified");
      }
    }

    if (user) {
      initialFormData.firstName =
        initialFormData.firstName ||
        user?.firstName ||
        user?.displayName?.split(" ")[0] ||
        "";
      initialFormData.lastName =
        initialFormData.lastName ||
        user?.lastName ||
        user?.displayName?.split(" ").slice(1).join(" ") ||
        "";
      initialFormData.phone =
        initialFormData.phone || user?.phone || user?.phoneNumber || "";
      initialFormData.email = initialFormData.email || user?.email || "";
    }
    setFormData(initialFormData);
    if (initialFormData.streetAddress) {
      setPlacesValue(initialFormData.streetAddress);
    }
  }, [user, setPlacesValue]);

  // Form data change hole localStorage e save korar effect
  useEffect(() => {
    localStorage.setItem("checkoutFormSimplified", JSON.stringify(formData));
  }, [formData]);

  // --- GEOLOCATION & SHIPPING CALCULATION ---

  // Coordinates theke address ber korar function
  const getAddressFromCoords = useCallback(
    async (lat, lng, originalDescription = null) => {
      if (!isGoogleMapsLoaded) return;
      try {
        const results = await getGeocode({ location: { lat, lng } });
        if (results && results[0]) {
          const address = results[0];
          const addressComponents = {
            streetAddress:
              originalDescription || address.formatted_address.split(",")[0],
            town: "",
            pinCode: "",
            country: "",
            latitude: lat,
            longitude: lng,
          };
          address.address_components.forEach((component) => {
            const types = component.types;
            if (types.includes("postal_town") || types.includes("locality")) {
              addressComponents.town = component.long_name;
            }
            if (types.includes("postal_code")) {
              addressComponents.pinCode = component.long_name;
            }
            if (types.includes("country")) {
              addressComponents.country = component.long_name;
            }
          });

          if (!addressComponents.country) {
            addressComponents.country = "United Kingdom";
          }

          setFormData((prev) => ({ ...prev, ...addressComponents }));
          setPlacesValue(addressComponents.streetAddress);
          toast.success("Address detected!");
        }
      } catch (error) {
        console.error("Reverse geocoding error:", error);
        toast.error("Could not detect address from coordinates.");
      } finally {
        setIsDetectingLocation(false);
      }
    },
    [isGoogleMapsLoaded, setPlacesValue]
  );

  // Location detection trigger korar function
  const handleDetectLocation = useCallback(() => {
    if (!isGoogleMapsLoaded) return;
    if (navigator.geolocation) {
      setIsDetectingLocation(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          getAddressFromCoords(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          toast.error(
            "Location access denied. Please allow location access in your browser settings."
          );
          console.error("Geolocation error:", error);
          setIsDetectingLocation(false);
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    } else {
      toast.error("Geolocation is not supported by your browser.");
    }
  }, [isGoogleMapsLoaded, getAddressFromCoords]);

  // Shudhu prothombar load howar shomoy location auto-detect korbe
  useEffect(() => {
    if (
      isGoogleMapsLoaded &&
      !formData.streetAddress &&
      !initialDetectionAttempted
    ) {
      handleDetectLocation();
      setInitialDetectionAttempted(true); // Flag set kora hocche jate abar na chole
    }
  }, [
    isGoogleMapsLoaded,
    formData.streetAddress,
    initialDetectionAttempted,
    handleDetectLocation,
  ]);

  // Address change hole shipping calculate korar effect
  useEffect(() => {
    const calculateShipping = async () => {
      if (
        !formData.streetAddress ||
        !formData.town ||
        !formData.pinCode ||
        !isGoogleMapsLoaded ||
        !shopCoords ||
        !window.google
      ) {
        setShippingCost(0);
        return;
      }

      setIsCalculatingShipping(true);
      const fullAddress = `${formData.streetAddress}, ${formData.town}, ${formData.country}, ${formData.pinCode}`;

      try {
        const geocodeResults = await getGeocode({ address: fullAddress });
        const { lat, lng } = await getLatLng(geocodeResults[0]);
        setUserCoords({ lat, lng });

        const directionsService = new window.google.maps.DirectionsService();
        const request = {
          origin: new window.google.maps.LatLng(shopCoords.lat, shopCoords.lng),
          destination: new window.google.maps.LatLng(lat, lng),
          travelMode: "DRIVING",
        };

        directionsService.route(request, (result, status) => {
          if (status === "OK") {
            const distanceInMeters = result.routes[0].legs[0].distance.value;
            const distanceInMiles = distanceInMeters / 1609.34;

            axios
              .get(
                `${baseUrl}shipping-zones/cost/by-distance?distance=${Math.ceil(
                  distanceInMiles
                )}`
              )
              .then((res) => {
                const cost = res?.data?.cost || 12.0;
                setNewShippingCost(cost);
                setShippingCost(cost);
                toast.success(
                  `Shipping calculated: £${cost.toFixed(
                    2
                  )} (${distanceInMiles.toFixed(1)} miles)`
                );
              })
              .catch((err) => {
                console.error("Error fetching shipping rates:", err);
                const fallbackCost = distanceInMiles > 12 ? 16.0 : 12.0;
                setShippingCost(fallbackCost);
                toast.error("Using fallback shipping rate.");
              });
          } else {
            console.error(`Directions request failed due to ${status}`);
            toast.error(
              "Could not calculate shipping distance. Please check your address."
            );
            setShippingCost(0);
          }
          setIsCalculatingShipping(false);
        });
      } catch (error) {
        console.error("Error geocoding address for shipping calc:", error);
        toast.error("Could not find address. Please check details.");
        setShippingCost(0);
        setIsCalculatingShipping(false);
      }
    };

    const handler = setTimeout(() => {
      calculateShipping();
    }, 1500);

    return () => clearTimeout(handler);
  }, [
    formData.streetAddress,
    formData.town,
    formData.pinCode,
    formData.country,
    isGoogleMapsLoaded,
    shopCoords,
    baseUrl,
  ]);

  // --- FORM VALIDATION & SUBMISSION ---

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.streetAddress.trim())
      newErrors.streetAddress = "Street address is required";
    if (!formData.town.trim()) newErrors.town = "Town/City is required";
    if (!formData.pinCode.trim()) newErrors.pinCode = "PIN Code is required";
    if (!formData.country.trim()) newErrors.country = "Country is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\+?[0-9\s-]{7,15}$/.test(formData.phone))
      newErrors.phone = "Enter a valid phone number";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Enter a valid email";
    if (!deliveryPriority)
      newErrors.deliveryPriority = "Delivery priority is required";

    if (
      shippingCost === 0 &&
      (formData.streetAddress || formData.town || formData.pinCode)
    ) {
      newErrors.shipping =
        "Shipping cost could not be calculated. Please check your address.";
    } else if (shippingCost === 0) {
      newErrors.shipping = "Please enter your address to calculate shipping.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "streetAddress") {
      setPlacesValue(value);
    }
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const handleSelectSuggestion = ({ description }) => {
    clearSuggestions();

    getGeocode({ address: description })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        getAddressFromCoords(lat, lng, description);
      })
      .catch((error) => {
        console.error("Error geocoding selected place:", error);
        toast.error("Could not use selected address.");
      });
  };

  const handleDeliveryPriorityChange = (e) => {
    setDeliveryPriority(e.target.value);
    if (errors.deliveryPriority) {
      setErrors((prevErrors) => ({ ...prevErrors, deliveryPriority: null }));
    }
  };

  // --- ORDER TOTALS CALCULATION ---
  const itemsSubtotalBeforeCartCoupon = useMemo(
    () =>
      productsFromCart.reduce(
        (total, item) => total + getItemPrice(item) * item.quantity,
        0
      ),
    [productsFromCart]
  );

  const cartCouponDiscountValue = appliedCouponFromCart
    ? parseFloat(appliedCouponFromCart.discountAmount || 0)
    : 0;

  const subtotalAfterCartCoupon =
    finalTotalAmountFromCart !== undefined
      ? parseFloat(finalTotalAmountFromCart)
      : itemsSubtotalBeforeCartCoupon;

  const grandTotal = subtotalAfterCartCoupon + shippingCost;

  const totalQuantity = productsFromCart.reduce(
    (total, item) => total + item.quantity,
    0
  );

  // --- FORM SUBMISSION HANDLER ---
  const handleSubmit = (e) => {
    e.preventDefault();
    if (itemsSubtotalBeforeCartCoupon < 25) {
      toast.error("Minimum order value is £25 (excluding shipping).");
      return;
    }
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly!");
      const firstErrorKey = Object.keys(errors)[0];
      if (firstErrorKey) {
        const errorElement = document.getElementById(firstErrorKey);
        if (errorElement) {
          errorElement.focus();
        }
      }
      return;
    }
    if (shippingCost === 0) {
      toast.error(
        "Shipping cost has not been calculated. Please check your address."
      );
      return;
    }

    const itemsPayload = productsFromCart.map((p) => ({
      product_id: p.product_id || p._id || p.id,
      product_name: p.product_name,
      quantity: p.quantity,
      price: (p.reguler_price || p.price || "0").toString(),
      discount_price: getItemPrice(p).toFixed(2),
      reguler_price: (p.reguler_price || p.price || "0").toString(),
      stock: p.stock ? p.stock.toString() : "0",
      productImage: p.productImage,
      selectedAttributes: p.selectedAttributes || {},
    }));

    const userInfoPayload = {
      email: formData.email,
      userId: user?.userId || user?._id || user?.uid || null,
      userName:
        user?.userName ||
        user?.displayName ||
        `${formData.firstName} ${formData.lastName}`,
      country: formData.country,
      phone: formData.phone,
      streetAddress1: formData.streetAddress,
      streetAddress2: formData.streetAddressExtra || null,
      city: formData.town,
      pinCode: formData.pinCode,
      itemsSubtotal: itemsSubtotalBeforeCartCoupon.toFixed(2),
      couponCodeApplied: appliedCouponFromCart
        ? appliedCouponFromCart.code
        : null,
      couponDiscountAmount: cartCouponDiscountValue.toFixed(2),
      subtotalAfterCoupon: subtotalAfterCartCoupon.toFixed(2),
      shippingAmount: shippingCost.toFixed(2),
      payableAmount: grandTotal.toFixed(2),
      deliveryPriority: deliveryPriority,
      latitude: userCoords?.lat || formData.latitude,
      longitude: userCoords?.lng || formData.longitude,
    };

    const dataToPassToPayment = {
      items: itemsPayload,
      userInfo: userInfoPayload,
    };

    navigate("/payment", { state: { fullFormData: dataToPassToPayment } });
  };

  // --- RENDER LOGIC ---

  if (!productsFromCart || productsFromCart.length < 1) {
    toast.error("Your cart is empty. Redirecting to shop...");
    return <Navigate to="/shop" replace />;
  }

  if (loadError) {
    return (
      <div className="container text-center p-5">
        <h4 className="text-danger">Error Loading Maps</h4>
        <p>
          Could not load Google Maps service. Please check your API key and
          network connection.
        </p>
      </div>
    );
  }

  if (!isGoogleMapsLoaded) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div className="text-center">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4 className="mt-3">Loading Checkout...</h4>
        </div>
      </div>
    );
  }

  return (
    <div
      className="checkout-page py-4 py-md-5"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container">
        <div className="text-center mb-4">
          <h1 className="fw-bold" style={{ color: "#e5272e" }}>
            Checkout
          </h1>
          <p className="text-muted">
            Please provide your shipping details to complete your order.
          </p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="row g-4">
            <div className="col-lg-7 col-md-6">
              <div className="card border-0 shadow-lg">
                <div className="card-body p-4 p-md-5">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0 fw-semibold" style={{ color: "#333" }}>
                      Shipping Details
                    </h3>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={handleDetectLocation}
                      disabled={isDetectingLocation}
                    >
                      {isDetectingLocation ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Detecting...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-location-arrow me-2"></i>
                          Detect My Location
                        </>
                      )}
                    </button>
                  </div>

                  {/* Name Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.firstName ? "is-invalid" : ""
                        }`}
                      />
                      {errors.firstName && (
                        <div className="invalid-feedback">
                          {errors.firstName}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName" className="form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.lastName ? "is-invalid" : ""
                        }`}
                      />
                      {errors.lastName && (
                        <div className="invalid-feedback">
                          {errors.lastName}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Street Address Autocomplete */}
                  <div className="mb-3 position-relative">
                    <label htmlFor="streetAddress" className="form-label">
                      Street Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="streetAddress"
                      name="streetAddress"
                      value={placesValue}
                      onChange={(e) => {
                        setPlacesValue(e.target.value);
                        setFormData((prev) => ({
                          ...prev,
                          streetAddress: e.target.value,
                        }));
                      }}
                      disabled={!ready}
                      className={`form-control mb-2 ${
                        errors.streetAddress ? "is-invalid" : ""
                      }`}
                      placeholder="Start typing your address..."
                    />
                    {status === "OK" && (
                      <div
                        className="list-group position-absolute w-100"
                        style={{ zIndex: 1000 }}
                      >
                        {suggestions.map((suggestion) => (
                          <button
                            type="button"
                            key={suggestion.place_id}
                            onClick={() => handleSelectSuggestion(suggestion)}
                            className="list-group-item list-group-item-action"
                          >
                            {suggestion.description}
                          </button>
                        ))}
                      </div>
                    )}
                    {errors.streetAddress && (
                      <div className="invalid-feedback d-block">
                        {errors.streetAddress}
                      </div>
                    )}
                    <input
                      type="text"
                      id="streetAddressExtra"
                      name="streetAddressExtra"
                      value={formData.streetAddressExtra}
                      onChange={handleChange}
                      className="form-control mt-2"
                      placeholder="Apartment, suite, etc. (Optional)"
                    />
                  </div>

                  {/* Town/City Field */}
                  <div className="mb-3">
                    <label htmlFor="town" className="form-label">
                      Town / City <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="town"
                      name="town"
                      value={formData.town}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.town ? "is-invalid" : ""
                      }`}
                    />
                    {errors.town && (
                      <div className="invalid-feedback">{errors.town}</div>
                    )}
                  </div>

                  {/* PIN Code Field */}
                  <div className="mb-3">
                    <label htmlFor="pinCode" className="form-label">
                      PIN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="pinCode"
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.pinCode ? "is-invalid" : ""
                      }`}
                    />
                    {errors.pinCode && (
                      <div className="invalid-feedback">{errors.pinCode}</div>
                    )}
                  </div>

                  {/* Country Field */}
                  <div className="mb-3">
                    <label htmlFor="country" className="form-label">
                      Country / Region <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="country"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.country ? "is-invalid" : ""
                      }`}
                    />
                    {errors.country && (
                      <div className="invalid-feedback">{errors.country}</div>
                    )}
                  </div>

                  {/* Delivery Priority Dropdown */}
                  <div className="mb-3">
                    <label htmlFor="deliveryPriority" className="form-label">
                      Delivery Priority <span className="text-danger">*</span>
                    </label>
                    <select
                      id="deliveryPriority"
                      name="deliveryPriority"
                      value={deliveryPriority}
                      onChange={handleDeliveryPriorityChange}
                      className={`form-select ${
                        errors.deliveryPriority ? "is-invalid" : ""
                      }`}
                    >
                      <option value="standard">Standard Delivery</option>
                      <option value="priority">Express Delivery</option>
                    </select>
                    {errors.deliveryPriority && (
                      <div className="invalid-feedback">
                        {errors.deliveryPriority}
                      </div>
                    )}
                  </div>

                  {/* Phone and Email Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="phone" className="form-label">
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.phone ? "is-invalid" : ""
                        }`}
                      />
                      {errors.phone && (
                        <div className="invalid-feedback">{errors.phone}</div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        readOnly={!!user?.email}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                      {!!user?.email && (
                        <small className="form-text text-muted">
                          Email pre-filled from your account.
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Summary Column */}
            <div className="col-lg-5 col-md-6">
              <div
                className="card border-0 shadow-lg"
                style={{ position: "sticky", top: "20px" }}
              >
                <div className="card-body p-4 p-md-5">
                  <h3 className="mb-4 fw-semibold" style={{ color: "#333" }}>
                    Your Order
                  </h3>
                  {productsFromCart.map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center mb-3 pb-3 border-bottom"
                    >
                      <img
                        src={
                          item.productImage ||
                          `https://placehold.co/60x60/E9ECEF/333?text=${
                            item.product_name
                              ? item.product_name.substring(0, 3)
                              : "Img"
                          }`
                        }
                        alt={item.product_name}
                        className="me-3 rounded"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://placehold.co/60x60/E9ECEF/333?text=Error";
                        }}
                      />
                      <div className="flex-grow-1">
                        <h6 className="mb-0 small fw-medium">
                          {item.product_name}
                        </h6>
                        <small className="text-muted">
                          Qty: {item.quantity}
                        </small>
                      </div>
                      <div className="text-end">
                        <span className="fw-medium">
                          £{(getItemPrice(item) * item.quantity).toFixed(2)}
                        </span>
                        {parseFloat(item.reguler_price || item.price || "0") >
                          getItemPrice(item) && (
                          <small className="d-block text-muted text-decoration-line-through">
                            £
                            {(
                              parseFloat(
                                item.reguler_price || item.price || "0"
                              ) * item.quantity
                            ).toFixed(2)}
                          </small>
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="mt-4">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Subtotal (items):</span>
                      <span
                        className="fw-medium"
                        style={{
                          textDecoration: appliedCouponFromCart
                            ? "line-through"
                            : "none",
                          color: appliedCouponFromCart ? "#6c757d" : "#212529",
                        }}
                      >
                        £{itemsSubtotalBeforeCartCoupon.toFixed(2)}
                      </span>
                    </div>
                    {appliedCouponFromCart && (
                      <div className="d-flex justify-content-between mb-2 text-success">
                        <span>Coupon ({appliedCouponFromCart.code}):</span>
                        <span className="fw-medium">
                          - £{cartCouponDiscountValue.toFixed(2)}
                        </span>
                      </div>
                    )}
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Shipping:</span>
                      <span className="fw-medium">
                        {isCalculatingShipping
                          ? "Calculating..."
                          : shippingCost > 0
                          ? `£${shippingCost.toFixed(2)}`
                          : "Enter address"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Total Items:</span>
                      <span className="fw-medium">{totalQuantity}</span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between mt-2 mb-4 fs-5">
                      <span className="fw-bold">Grand Total:</span>
                      <span className="fw-bold" style={{ color: "#e5272e" }}>
                        £{grandTotal.toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <button
                    type="submit"
                    disabled={
                      shippingCost === 0 ||
                      isCalculatingShipping ||
                      productsFromCart.length === 0
                    }
                    className="btn w-100 py-2 fs-5 fw-bold"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, #e5272e, #f59332)",
                      color: "white",
                      border: "none",
                    }}
                  >
                    Proceed to Payment
                  </button>
                  {errors.shipping && (
                    <small className="d-block text-start mt-2 text-danger">
                      {errors.shipping}
                    </small>
                  )}
                  {itemsSubtotalBeforeCartCoupon < 25 &&
                    productsFromCart.length > 0 && (
                      <small className="d-block text-start mt-2 text-danger">
                        Please note that the minimum order value is £25,
                        excluding shipping costs.
                      </small>
                    )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Checkout;
